<template>
  <div style="background: #fff" class="p-3 h-100">
    <b-card header="사전예약 카드 등록"
            header-tag="div">
      <h5 :class="labelClasses">제목</h5>
      <p>{{pregWithMoment.name}}</p>
      <b-form v-on:submit.prevent="submitHandling">
        <h5 :class="labelClasses">OS</h5>
        <p>{{cardDto.osType}}</p>

        <h5 :class="labelClasses">사전예약 기간</h5>
        <p style="color: #F53838">{{this.pregWithMoment.startTime.format('YYYY-MM-DD HH:mm:ss')}} ~ {{this.pregWithMoment.endTime.format('YYYY-MM-DD HH:mm:ss')}}</p>

        <h5 :class="labelClasses">사전예약 카드 노출 일정</h5>
        <b-form-group
                label="시작"
                label-for="startShowTime" :horizontal="true" :label-cols="1">
          <date-picker id="startShowTime" :value="cardDto.startTime" v-on:input="cardDto.startTime = new Date($event)" :config="dateOptions"></date-picker>
        </b-form-group>
        <b-form-group
                label="종료"
                label-for="endShowTime" :horizontal="true" :label-cols="1">
          <date-picker id="endShowTime" :value="cardDto.endTime" v-on:input="cardDto.endTime = new Date($event)" :config="endOptions"></date-picker>
        </b-form-group>

        <b-form-group
                label="노출 지면 선택"
                :label-class="labelClasses">
          <b-form-radio-group v-model="cardDto.slotNo" :options="slotOptions"></b-form-radio-group>
        </b-form-group>

        <h5 :class="labelClasses">사전예약 카드 소재 (Ko/EN/JP/CH)</h5>
        <p class="card-text d-inline-block">이미지</p>
        <p class="card-text" v-for="(value, key) in pregWithMoment.viewInfo.listIconImage" v-bind:key="'listIconImage'+key">
          <span>{{key}} :</span>
          <br>
          <img :src=value v-if="value" width="320">
          <span v-else>없음</span>
        </p>
        <div v-if="cardDto.osType === 'android'">
          <p class="card-text mb-0">문구 (googlePlay)</p>
          <p class="card-text" v-for="(value, key) in pregWithMoment.listShortDescForAos" v-bind:key="'listShortDescForAos'+key">
            <span>{{key}} :</span>
            <br>
            <span v-if="value">{{value}}</span>
            <span v-else>없음</span>
          </p>
        </div>
        <div v-if="cardDto.osType === 'ios'" class="mt-4">
          <p class="card-text mb-0">한 줄 요약 (appStore)</p>
          <p class="card-text" v-for="(value, key) in pregWithMoment.listShortDescForIos" v-bind:key="'listShortDescForIos'+key">
            <span>{{key}} :</span>
            <br>
            <span v-if="value">{{value}}</span>
            <span v-else>없음</span>
          </p>
        </div>

        <b-row class="align-items-center mt-3">
          <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <b-button block variant="outline-primary" type="submit">등록</b-button>
          </b-col>
          <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <b-button block variant="outline-secondary" v-on:click="$router.go(-1)">뒤로</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import { labelClasses, DISPLAY_STATE } from '@/constants'
import { MODULE_NAME as PREG_MODULE, FETCH_PREG, FETCH_CODES } from '@/store/preg/actions.type'
import { mapGetters, mapMutations } from 'vuex'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import { $showModalWithErrorMsg } from '@/common/util'
import playGameService from '@/common/api/playGame.service'
export default {
  data () {
    return {
      slotOptions: [{
        value: 1,
        text: 'CARD 01'
      }, {
        value: 2,
        text: 'CARD 02'
      }],
      labelClasses: labelClasses,
      dateOptions: {
        format: 'YYYY-MM-DD HH:mm:ss',
        useCurrent: true
      },
      cardDto: {
        pregName: '',
        permaUri: '',
        osType: '',
        slotNo: 1,
        pregMasterId: this.$route.params.pregId,
        startTime: null,
        endTime: null,
        displayYn: DISPLAY_STATE.ON
      }
    }
  },
  mounted () {
    this.$store.dispatch(PREG_MODULE + FETCH_CODES)
      .catch($showModalWithErrorMsg.bind(this))
    this.$store.dispatch(PREG_MODULE + FETCH_PREG, this.$route.params.pregId)
      .catch($showModalWithErrorMsg.bind(this))
    if (this.$route.query.market === 'googlePlay') {
      this.cardDto.osType = 'android'
    } else {
      this.cardDto.osType = 'ios'
    }

  },
  computed: {
    endOptions () {
      return Object.assign({}, this.dateOptions, {minDate: this.cardDto.startTime})
    },
    ...mapGetters('preg', [
      'pregWithMoment'
    ])
  },
  methods: {
    submitHandling (e) {
      this.cardDto.pregName = this.pregWithMoment.name
      this.cardDto.permaUri = this.pregWithMoment.permaUri

      playGameService.createV3PregCard(this.cardDto)
        .then((res) => {
          this[SHOW_MODAL]({msg: '등록이 완료되었습니다.', okHandling: () => { this.$router.push({name: 'cardListContents'}) }})
        })
        .catch((err) => {
          if (err.response.data.msg) {
            this[SHOW_MODAL]({msg: err.response.data.msg, okHandling: () => {}})
          } else {
            throw err
          }
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    // dateInputHandler (input, property) {
    //   this[property] = new Date(input)
    //   this.cardDto.pregMasterMarketInfoList.forEach((element) => {
    //     if (element.marketType === this.$route.query.market) {
    //       element[property] = new Date(input)
    //     }
    //   })
    // },
    ...mapMutations('ui', [SHOW_MODAL])
  }
}
</script>
